// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   AGCX Earn New Page Styles
   File: earn-new.css
   ========================================================================== */

.earn-new-page {
    font-family: 'Inter', 'Outfit', system-ui, -apple-system, sans-serif;
    background-color: #FFFFFF;
    color: #111827;
    padding: 40px 0 100px 0;
    position: relative;
    overflow: hidden;
}

.earn-container {
    max-width: 1480px;
    margin: 0 auto;
    padding: 0 20px;
    position: relative;
    z-index: 1;
}

.gold-text {
    color: #D3B06C;
    font-weight: 700;
}

/* ==========================================================================
   1. HERO SECTION
   ========================================================================== */
.earn-hero {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 40px;
    margin-bottom: 60px;
    position: relative;
}

.earn-hero-left {
    flex: 1 1;
    max-width: 600px;
}

.earn-hero-title {
    font-size: 54px;
    font-weight: 700;
    color: #111827;
    line-height: 1.15;
    margin: 0 0 16px 0;
    letter-spacing: -0.5px;
}

.earn-hero-desc {
    font-size: 17px;
    color: #6B7280;
    line-height: 1.6;
    margin: 0 0 28px 0;
}

.earn-badges-row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 32px;
    flex-wrap: wrap;
}

.earn-badge-pill {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    background-color: #FAFAFA;
    border: 1px solid #F3F4F6;
    border-radius: 50px;
    font-size: 14px;
    font-weight: 600;
}

.earn-badge-pill img {
    width: 18px;
    height: 18px;
    object-fit: contain;
    flex-shrink: 0;
}

.btn-start-earning {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 14px 32px;
    background-color: #D1AA67;
    color: #FFFFFF;
    font-size: 15px;
    font-weight: 600;
    border: none;
    border-radius: 50px;
    cursor: pointer;
    box-shadow: 0 4px 14px rgba(211, 176, 108, 0.25);
    transition: all 0.25s ease;
    text-decoration: none;
}

.btn-start-earning:hover {
    background-color: #C09D5B;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(211, 176, 108, 0.35);
    color: #FFFFFF;
}

.earn-hero-right {
    width: 620px;
    max-width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.earn-hero-right img {
    max-width: 100%;
    height: auto;
    object-fit: contain;
}


/* ==========================================================================
   2. TOP CRYPTO APY CARDS BAR
   ========================================================================== */
.earn-crypto-bar {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 20px;
    margin-bottom: 40px;
}

.crypto-apy-card {
    background-color: #FFFFFF;
    border: 1px solid #F3F4F6;
    border-radius: 18px;
    padding: 20px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);
    transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.crypto-apy-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
}

.crypto-card-top {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;
}

.crypto-coin-icon {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    object-fit: contain;
    flex-shrink: 0;
}

.crypto-coin-icon.agce-gold-bg,
.coin-cell-icon.agce-gold-bg {
    background-color: #D3B06C;
    padding: 6px;
    border-radius: 50%;
    box-shadow: 0 2px 8px rgba(211, 176, 108, 0.35);
}

.crypto-info-name h4 {
    font-size: 15px;
    font-weight: 700;
    color: #111827;
    margin: 0;
}

.crypto-info-name span {
    font-size: 12px;
    color: #9CA3AF;
}

.crypto-card-bottom-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
}

.crypto-apy-rate {
    font-size: 22px;
    font-weight: 800;
    color: #D3B06C;
    line-height: 1.2;
    margin-bottom: 2px;
}

.crypto-apy-label {
    font-size: 13px;
    font-weight: 500;
    color: #9CA3AF;
}

.crypto-trade-link {
    font-size: 12.5px;
    font-weight: 600;
    color: #D3B06C;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    transition: color 0.2s ease;
}

.crypto-trade-link:hover {
    color: #B8924E;
    text-decoration: underline;
}


/* ==========================================================================
   3. FEATURE CARDS (SMART EARN & AUTO SUBSCRIBE)
   ========================================================================== */
.earn-features-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
    margin-bottom: 80px;
}

.earn-feature-card {
    background: linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(255, 247, 234, 1) 100%);
    border: 1px solid #E8E8E880;
    border-radius: 24px;
    padding: 32px 36px;
    display: flex;
    align-items: flex-start;
    gap: 20px;
    box-shadow: 0 2px 15px rgb(0 0 0 / 5%);
}

.feature-card-icon {
    width: 70px;
    height: 70px;
    border-radius: 100px;
    background: linear-gradient(180deg, rgba(255, 239, 211, 1) 0%, rgba(255, 255, 255, 1) 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.feature-card-icon img {
    object-fit: contain;
}

.feature-card-content h3 {
    font-size: 18px;
    font-weight: 700;
    color: #111827;
    margin: 0 0 8px 0;
}

.feature-card-content p {
    font-size: 13.5px;
    color: #6B7280;
    line-height: 1.55;
    margin: 0 0 16px 0;
}

.feature-card-content a {
    font-size: 14px;
    font-weight: 600;
    color: #D1AA67;
    text-decoration: none;
}

.feature-card-content a:hover {
    text-decoration: underline;
}


/* ==========================================================================
   4. ALL EARNING PRODUCTS TABLE & CUSTOM DROPDOWNS
   ========================================================================== */
.all-products-section {
    margin-bottom: 90px;
}

.products-header-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 28px;
}

.products-header-row h2 {
    font-size: 40px;
    font-weight: 600;
    /* color: #111827; */
    margin: 0;
}

.products-filters-right {
    display: flex;
    align-items: center;
    gap: 12px;
}

/* Custom Dropdown Styling */
.custom-dropdown-wrap {
    position: relative;
}

.custom-dropdown-btn {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 9px 18px;
    border: 1px solid #E5E7EB;
    border-radius: 12px;
    background-color: #fff;
    font-size: 13.5px;
    font-weight: 500;
    color: #374151;
    cursor: pointer;
    transition: all 0.2s ease;
    min-width: 120px;
    justify-content: space-between;
}

.custom-dropdown-btn:hover,
.custom-dropdown-btn.open {
    border-color: #D3B06C;
    background-color: #FFFFFF;
    box-shadow: 0 2px 10px rgba(211, 176, 108, 0.15);
}

.custom-dropdown-btn i {
    font-size: 16px;
    color: #9CA3AF;
    transition: transform 0.2s ease;
}

.custom-dropdown-btn.open i {
    transform: rotate(180deg);
    color: #D3B06C;
}

.custom-dropdown-menu {
    position: absolute;
    top: calc(100% + 6px);
    right: 0;
    min-width: 140px;
    background-color: #FFFFFF;
    border: 1px solid #F3F4F6;
    border-radius: 14px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
    padding: 6px;
    z-index: 100;
    animation: dropdownFadeIn 0.2s ease;
}

@keyframes dropdownFadeIn {
    from {
        opacity: 0;
        transform: translateY(-6px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.custom-dropdown-item {
    padding: 10px 14px;
    font-size: 13px;
    font-weight: 500;
    color: #4B5563;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.15s ease;
}

.custom-dropdown-item:hover {
    background-color: #FFFDF7;
    color: #D3B06C;
}

.custom-dropdown-item.active {
    background-color: #FEF3C7;
    color: #D97706;
    font-weight: 700;
}

.filter-search-btn {
    width: 38px;
    height: 38px;
    border: 1px solid #E5E7EB;
    border-radius: 12px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #6B7280;
    cursor: pointer;
    transition: all 0.2s ease;
}

.filter-search-btn:hover {
    border-color: #D3B06C;
    color: #D3B06C;
    background-color: #FFFFFF;
}

.products-table-card {
    background-color: #FFFFFF;
    border: 1px solid #F3F4F6;
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.03);
    margin-bottom: 32px;
}

.products-table {
    width: 100%;
    border-collapse: collapse;
    text-align: left;
}

.products-table th {
    background-color: #FAFAFA;
    padding: 18px 32px;
    font-size: 13px;
    font-weight: 600;
    color: #9CA3AF;
    letter-spacing: 0.2px;
    border-bottom: 1px solid #F3F4F6;
}

.products-table td {
    padding: 20px 32px;
    border-bottom: 1px solid #F8FAFC;
    font-size: 14px;
    color: #111827;
    vertical-align: middle;
}

.products-table tr:last-child td {
    border-bottom: none;
}

.coin-cell-info {
    display: flex;
    align-items: center;
    gap: 12px;
    font-weight: 700;
}

.coin-cell-icon {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    object-fit: contain;
    flex-shrink: 0;
}

.products-table td.apr-highlight,
.apr-highlight {
    font-weight: 700;
    color: #38B781 !important;
    font-size: 15px;
}

.status-badge-active {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 4px 14px;
    background-color: #ECFDF5;
    color: #38B781;
    font-size: 12.5px;
    font-weight: 600;
    border-radius: 50px;
}

.status-badge-active i {
    color: #38B781;
    font-size: 14px;
}

.btn-table-trade {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 18px;
    background-color: #FFFDF7;
    border: 1px solid #FDE68A;
    border-radius: 50px;
    color: #D97706;
    font-size: 13px;
    font-weight: 600;
    text-decoration: none;
    transition: all 0.2s ease;
}

.btn-table-trade:hover {
    background-color: #D3B06C;
    color: #FFFFFF;
    border-color: #D3B06C;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(211, 176, 108, 0.25);
}

.table-footer-btn-wrap {
    display: flex;
    justify-content: center;
}

.btn-view-more-products {
    padding: 12px 36px;
    background-color: #D3B06C;
    color: #FFFFFF;
    font-size: 14px;
    font-weight: 600;
    border: none;
    border-radius: 50px;
    cursor: pointer;
    box-shadow: 0 4px 14px rgba(211, 176, 108, 0.25);
    transition: all 0.25s ease;
}

.btn-view-more-products:hover {
    background-color: #C09D5B;
    transform: translateY(-1px);
}


/* ==========================================================================
   5. FREQUENTLY ASKED QUESTIONS (2-COLUMN INTERACTIVE ACCORDION)
   ========================================================================== */
.earn-faq-section {
    margin-bottom: 80px;
}

.faq-title {
    font-size: 40px;
    font-weight: 600;
    margin: 0 0 36px 0;
}

.faq-grid-2col {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    align-items: start;
}

.faq-col {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.faq-card-item {
    background-color: #FFFFFF;
    border: 1px solid #F3F4F6;
    border-radius: 16px;
    padding: 20px 24px;
    cursor: pointer;
    transition: all 0.25s ease;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.02);
}

.faq-card-item:hover {
    border-color: #FDE68A;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
}

.faq-card-item.active {
    border-color: #D3B06C;
    background-color: #FFFDF7;
    box-shadow: 0 4px 16px rgba(211, 176, 108, 0.12);
}

.faq-card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
}

.faq-card-question {
    font-size: 18px;
    font-weight: 500;
    /* color: #111827; */
    margin: 0;
    flex: 1 1;
}

.faq-plus-icon {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background-color: #FFEFD3;
    color: #D97706;
    font-size: 14px;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: transform 0.25s ease, background-color 0.25s ease;
}

.faq-card-item.active .faq-plus-icon {
    background-color: #D3B06C;
    color: #FFFFFF;
}

.faq-card-answer {
    margin-top: 14px;
    padding-top: 14px;
    border-top: 1px dashed #E5E7EB;
    font-size: 13.5px;
    color: #4B5563;
    line-height: 1.6;
    animation: fadeIn 0.25s ease;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(-4px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}


/* ==========================================================================
   RESPONSIVE ADJUSTMENTS
   ========================================================================== */

@media (max-width:1500px) {

    .earn-container {
        max-width: 95%;
    }

    .earn-hero-title {
        font-size: 48px;
    }

}


@media (max-width: 1200px) {


    .earn-hero-right {
        width: 50%;
    }

    .products-header-row h2 {
        font-size: 32px;
    }

    .faq-title {
        font-size: 32px;
        margin: 0 0 26px 0;
    }

}

@media (max-width: 991px) {


    .earn-hero-title {
        font-size: 32px;
        margin-bottom: 10px;
    }

    .earn-hero-desc {
        font-size: 15px;
        margin: 0 0 22px 0;
    }

    .earn-new-page {
        padding: 40px 0 40px 0;
    }


    .faq-card-question {
        font-size: 15px;
    }

    .earn-crypto-bar {
        grid-template-columns: repeat(2, 1fr);
    }

    .products-header-row {
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
    }
}

@media (max-width: 767px) {


    .earn-hero {
        text-align: center;
        flex-direction: column;
        gap: 30px;
        margin-bottom: 40px;
    }

    .earn-badges-row {
        justify-content: center;
        margin-bottom: 24px;
    }

    .earn-badge-pill {
        gap: 6px;
        padding: 7px 14px;
        font-size: 13px;
    }

    .btn-start-earning {
        gap: 8px;
        padding: 10px 26px;
        font-size: 12px;
    }

    .earn-hero-right {
        width: 280px;
    }

    .products-header-row h2 {
        font-size: 24px;
    }

    .faq-title {
        font-size: 24px;
        margin: 0 0 24px 0;
    }

    .all-products-section {
        margin-bottom: 40px;
    }

    .earn-faq-section {
        margin-bottom: 20px;
    }

    .faq-card-item {
        padding: 18px;
    }

}


@media (max-width: 580px) {

    .earn-crypto-bar {
        grid-template-columns: repeat(1, 1fr);
    }

    .crypto-apy-card {
        display: flex;
        justify-content: space-between;
        align-items: start;
    }

    .crypto-apy-rate {
        font-size: 18px;
    }

    .earn-feature-card {
        border-radius: 20px;
        padding: 22px;
    }

    .faq-grid-2col {
        grid-template-columns: 1fr;
    }

    .earn-features-grid {
        grid-template-columns: 1fr;
        margin-bottom: 40px;
    }

    .faq-title {
        font-size: 22px;
    }

}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/EarnNew/earn-new.css"],"names":[],"mappings":"AAAA;;;+EAG+E;;AAE/E;IACI,oEAAoE;IACpE,yBAAyB;IACzB,cAAc;IACd,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;;+EAE+E;AAC/E;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gDAAgD;IAChD,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,gDAAgD;IAChD,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;AACvB;;;AAGA;;+EAE+E;AAC/E;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,0CAA0C;IAC1C,uDAAuD;AAC3D;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,+CAA+C;AACnD;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;;AAGA;;+EAE+E;AAC/E;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,0FAA0F;IAC1F,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,sCAAsC;AAC1C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,2FAA2F;IAC3F,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;;AAGA;;+EAE+E;AAC/E;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA,4BAA4B;AAC5B;IACI,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;;IAEI,qBAAqB;IACrB,yBAAyB;IACzB,gDAAgD;AACpD;;AAEA;IACI,eAAe;IACf,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,QAAQ;IACR,gBAAgB;IAChB,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,0CAA0C;IAC1C,YAAY;IACZ,YAAY;IACZ,mCAAmC;AACvC;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,0CAA0C;IAC1C,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;IACf,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;IACrB,2BAA2B;IAC3B,gDAAgD;AACpD;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gDAAgD;IAChD,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;;AAGA;;+EAE+E;AAC/E;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,0BAA0B;IAC1B,yCAAyC;AAC7C;;AAEA;IACI,qBAAqB;IACrB,0CAA0C;AAC9C;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,gDAAgD;AACpD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,SAAS;IACT,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,6DAA6D;AACjE;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,8BAA8B;IAC9B,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;;AAGA;;+EAE+E;;AAE/E;;IAEI;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;AAEJ;;;AAGA;;;IAGI;QACI,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;AAEJ;;AAEA;;;IAGI;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;IAC1B;;;IAGA;QACI,eAAe;IACnB;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;AACJ;;AAEA;;;IAGI;QACI,kBAAkB;QAClB,sBAAsB;QACtB,SAAS;QACT,mBAAmB;IACvB;;IAEA;QACI,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,QAAQ;QACR,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,QAAQ;QACR,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;AAEJ;;;AAGA;;IAEI;QACI,qCAAqC;IACzC;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,aAAa;IACjB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;QAC1B,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;AAEJ","sourcesContent":["/* ==========================================================================\n   AGCX Earn New Page Styles\n   File: earn-new.css\n   ========================================================================== */\n\n.earn-new-page {\n    font-family: 'Inter', 'Outfit', system-ui, -apple-system, sans-serif;\n    background-color: #FFFFFF;\n    color: #111827;\n    padding: 40px 0 100px 0;\n    position: relative;\n    overflow: hidden;\n}\n\n.earn-container {\n    max-width: 1480px;\n    margin: 0 auto;\n    padding: 0 20px;\n    position: relative;\n    z-index: 1;\n}\n\n.gold-text {\n    color: #D3B06C;\n    font-weight: 700;\n}\n\n/* ==========================================================================\n   1. HERO SECTION\n   ========================================================================== */\n.earn-hero {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 40px;\n    margin-bottom: 60px;\n    position: relative;\n}\n\n.earn-hero-left {\n    flex: 1;\n    max-width: 600px;\n}\n\n.earn-hero-title {\n    font-size: 54px;\n    font-weight: 700;\n    color: #111827;\n    line-height: 1.15;\n    margin: 0 0 16px 0;\n    letter-spacing: -0.5px;\n}\n\n.earn-hero-desc {\n    font-size: 17px;\n    color: #6B7280;\n    line-height: 1.6;\n    margin: 0 0 28px 0;\n}\n\n.earn-badges-row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 32px;\n    flex-wrap: wrap;\n}\n\n.earn-badge-pill {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 16px;\n    background-color: #FAFAFA;\n    border: 1px solid #F3F4F6;\n    border-radius: 50px;\n    font-size: 14px;\n    font-weight: 600;\n}\n\n.earn-badge-pill img {\n    width: 18px;\n    height: 18px;\n    object-fit: contain;\n    flex-shrink: 0;\n}\n\n.btn-start-earning {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    padding: 14px 32px;\n    background-color: #D1AA67;\n    color: #FFFFFF;\n    font-size: 15px;\n    font-weight: 600;\n    border: none;\n    border-radius: 50px;\n    cursor: pointer;\n    box-shadow: 0 4px 14px rgba(211, 176, 108, 0.25);\n    transition: all 0.25s ease;\n    text-decoration: none;\n}\n\n.btn-start-earning:hover {\n    background-color: #C09D5B;\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(211, 176, 108, 0.35);\n    color: #FFFFFF;\n}\n\n.earn-hero-right {\n    width: 620px;\n    max-width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.earn-hero-right img {\n    max-width: 100%;\n    height: auto;\n    object-fit: contain;\n}\n\n\n/* ==========================================================================\n   2. TOP CRYPTO APY CARDS BAR\n   ========================================================================== */\n.earn-crypto-bar {\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    gap: 20px;\n    margin-bottom: 40px;\n}\n\n.crypto-apy-card {\n    background-color: #FFFFFF;\n    border: 1px solid #F3F4F6;\n    border-radius: 18px;\n    padding: 20px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);\n    transition: transform 0.25s ease, box-shadow 0.25s ease;\n}\n\n.crypto-apy-card:hover {\n    transform: translateY(-3px);\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);\n}\n\n.crypto-card-top {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 16px;\n}\n\n.crypto-coin-icon {\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    object-fit: contain;\n    flex-shrink: 0;\n}\n\n.crypto-coin-icon.agce-gold-bg,\n.coin-cell-icon.agce-gold-bg {\n    background-color: #D3B06C;\n    padding: 6px;\n    border-radius: 50%;\n    box-shadow: 0 2px 8px rgba(211, 176, 108, 0.35);\n}\n\n.crypto-info-name h4 {\n    font-size: 15px;\n    font-weight: 700;\n    color: #111827;\n    margin: 0;\n}\n\n.crypto-info-name span {\n    font-size: 12px;\n    color: #9CA3AF;\n}\n\n.crypto-card-bottom-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n}\n\n.crypto-apy-rate {\n    font-size: 22px;\n    font-weight: 800;\n    color: #D3B06C;\n    line-height: 1.2;\n    margin-bottom: 2px;\n}\n\n.crypto-apy-label {\n    font-size: 13px;\n    font-weight: 500;\n    color: #9CA3AF;\n}\n\n.crypto-trade-link {\n    font-size: 12.5px;\n    font-weight: 600;\n    color: #D3B06C;\n    text-decoration: none;\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    transition: color 0.2s ease;\n}\n\n.crypto-trade-link:hover {\n    color: #B8924E;\n    text-decoration: underline;\n}\n\n\n/* ==========================================================================\n   3. FEATURE CARDS (SMART EARN & AUTO SUBSCRIBE)\n   ========================================================================== */\n.earn-features-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 24px;\n    margin-bottom: 80px;\n}\n\n.earn-feature-card {\n    background: linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(255, 247, 234, 1) 100%);\n    border: 1px solid #E8E8E880;\n    border-radius: 24px;\n    padding: 32px 36px;\n    display: flex;\n    align-items: flex-start;\n    gap: 20px;\n    box-shadow: 0 2px 15px rgb(0 0 0 / 5%);\n}\n\n.feature-card-icon {\n    width: 70px;\n    height: 70px;\n    border-radius: 100px;\n    background: linear-gradient(180deg, rgba(255, 239, 211, 1) 0%, rgba(255, 255, 255, 1) 100%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.feature-card-icon img {\n    object-fit: contain;\n}\n\n.feature-card-content h3 {\n    font-size: 18px;\n    font-weight: 700;\n    color: #111827;\n    margin: 0 0 8px 0;\n}\n\n.feature-card-content p {\n    font-size: 13.5px;\n    color: #6B7280;\n    line-height: 1.55;\n    margin: 0 0 16px 0;\n}\n\n.feature-card-content a {\n    font-size: 14px;\n    font-weight: 600;\n    color: #D1AA67;\n    text-decoration: none;\n}\n\n.feature-card-content a:hover {\n    text-decoration: underline;\n}\n\n\n/* ==========================================================================\n   4. ALL EARNING PRODUCTS TABLE & CUSTOM DROPDOWNS\n   ========================================================================== */\n.all-products-section {\n    margin-bottom: 90px;\n}\n\n.products-header-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 28px;\n}\n\n.products-header-row h2 {\n    font-size: 40px;\n    font-weight: 600;\n    /* color: #111827; */\n    margin: 0;\n}\n\n.products-filters-right {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n/* Custom Dropdown Styling */\n.custom-dropdown-wrap {\n    position: relative;\n}\n\n.custom-dropdown-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 10px;\n    padding: 9px 18px;\n    border: 1px solid #E5E7EB;\n    border-radius: 12px;\n    background-color: #fff;\n    font-size: 13.5px;\n    font-weight: 500;\n    color: #374151;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    min-width: 120px;\n    justify-content: space-between;\n}\n\n.custom-dropdown-btn:hover,\n.custom-dropdown-btn.open {\n    border-color: #D3B06C;\n    background-color: #FFFFFF;\n    box-shadow: 0 2px 10px rgba(211, 176, 108, 0.15);\n}\n\n.custom-dropdown-btn i {\n    font-size: 16px;\n    color: #9CA3AF;\n    transition: transform 0.2s ease;\n}\n\n.custom-dropdown-btn.open i {\n    transform: rotate(180deg);\n    color: #D3B06C;\n}\n\n.custom-dropdown-menu {\n    position: absolute;\n    top: calc(100% + 6px);\n    right: 0;\n    min-width: 140px;\n    background-color: #FFFFFF;\n    border: 1px solid #F3F4F6;\n    border-radius: 14px;\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n    padding: 6px;\n    z-index: 100;\n    animation: dropdownFadeIn 0.2s ease;\n}\n\n@keyframes dropdownFadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(-6px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.custom-dropdown-item {\n    padding: 10px 14px;\n    font-size: 13px;\n    font-weight: 500;\n    color: #4B5563;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.15s ease;\n}\n\n.custom-dropdown-item:hover {\n    background-color: #FFFDF7;\n    color: #D3B06C;\n}\n\n.custom-dropdown-item.active {\n    background-color: #FEF3C7;\n    color: #D97706;\n    font-weight: 700;\n}\n\n.filter-search-btn {\n    width: 38px;\n    height: 38px;\n    border: 1px solid #E5E7EB;\n    border-radius: 12px;\n    background-color: #fff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #6B7280;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.filter-search-btn:hover {\n    border-color: #D3B06C;\n    color: #D3B06C;\n    background-color: #FFFFFF;\n}\n\n.products-table-card {\n    background-color: #FFFFFF;\n    border: 1px solid #F3F4F6;\n    border-radius: 20px;\n    overflow: hidden;\n    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.03);\n    margin-bottom: 32px;\n}\n\n.products-table {\n    width: 100%;\n    border-collapse: collapse;\n    text-align: left;\n}\n\n.products-table th {\n    background-color: #FAFAFA;\n    padding: 18px 32px;\n    font-size: 13px;\n    font-weight: 600;\n    color: #9CA3AF;\n    letter-spacing: 0.2px;\n    border-bottom: 1px solid #F3F4F6;\n}\n\n.products-table td {\n    padding: 20px 32px;\n    border-bottom: 1px solid #F8FAFC;\n    font-size: 14px;\n    color: #111827;\n    vertical-align: middle;\n}\n\n.products-table tr:last-child td {\n    border-bottom: none;\n}\n\n.coin-cell-info {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    font-weight: 700;\n}\n\n.coin-cell-icon {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    object-fit: contain;\n    flex-shrink: 0;\n}\n\n.products-table td.apr-highlight,\n.apr-highlight {\n    font-weight: 700;\n    color: #38B781 !important;\n    font-size: 15px;\n}\n\n.status-badge-active {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    padding: 4px 14px;\n    background-color: #ECFDF5;\n    color: #38B781;\n    font-size: 12.5px;\n    font-weight: 600;\n    border-radius: 50px;\n}\n\n.status-badge-active i {\n    color: #38B781;\n    font-size: 14px;\n}\n\n.btn-table-trade {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 6px 18px;\n    background-color: #FFFDF7;\n    border: 1px solid #FDE68A;\n    border-radius: 50px;\n    color: #D97706;\n    font-size: 13px;\n    font-weight: 600;\n    text-decoration: none;\n    transition: all 0.2s ease;\n}\n\n.btn-table-trade:hover {\n    background-color: #D3B06C;\n    color: #FFFFFF;\n    border-color: #D3B06C;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(211, 176, 108, 0.25);\n}\n\n.table-footer-btn-wrap {\n    display: flex;\n    justify-content: center;\n}\n\n.btn-view-more-products {\n    padding: 12px 36px;\n    background-color: #D3B06C;\n    color: #FFFFFF;\n    font-size: 14px;\n    font-weight: 600;\n    border: none;\n    border-radius: 50px;\n    cursor: pointer;\n    box-shadow: 0 4px 14px rgba(211, 176, 108, 0.25);\n    transition: all 0.25s ease;\n}\n\n.btn-view-more-products:hover {\n    background-color: #C09D5B;\n    transform: translateY(-1px);\n}\n\n\n/* ==========================================================================\n   5. FREQUENTLY ASKED QUESTIONS (2-COLUMN INTERACTIVE ACCORDION)\n   ========================================================================== */\n.earn-faq-section {\n    margin-bottom: 80px;\n}\n\n.faq-title {\n    font-size: 40px;\n    font-weight: 600;\n    margin: 0 0 36px 0;\n}\n\n.faq-grid-2col {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 16px;\n    align-items: start;\n}\n\n.faq-col {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.faq-card-item {\n    background-color: #FFFFFF;\n    border: 1px solid #F3F4F6;\n    border-radius: 16px;\n    padding: 20px 24px;\n    cursor: pointer;\n    transition: all 0.25s ease;\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.02);\n}\n\n.faq-card-item:hover {\n    border-color: #FDE68A;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);\n}\n\n.faq-card-item.active {\n    border-color: #D3B06C;\n    background-color: #FFFDF7;\n    box-shadow: 0 4px 16px rgba(211, 176, 108, 0.12);\n}\n\n.faq-card-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 16px;\n}\n\n.faq-card-question {\n    font-size: 18px;\n    font-weight: 500;\n    /* color: #111827; */\n    margin: 0;\n    flex: 1 1;\n}\n\n.faq-plus-icon {\n    width: 26px;\n    height: 26px;\n    border-radius: 50%;\n    background-color: #FFEFD3;\n    color: #D97706;\n    font-size: 14px;\n    font-weight: 400;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    transition: transform 0.25s ease, background-color 0.25s ease;\n}\n\n.faq-card-item.active .faq-plus-icon {\n    background-color: #D3B06C;\n    color: #FFFFFF;\n}\n\n.faq-card-answer {\n    margin-top: 14px;\n    padding-top: 14px;\n    border-top: 1px dashed #E5E7EB;\n    font-size: 13.5px;\n    color: #4B5563;\n    line-height: 1.6;\n    animation: fadeIn 0.25s ease;\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(-4px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n\n/* ==========================================================================\n   RESPONSIVE ADJUSTMENTS\n   ========================================================================== */\n\n@media (max-width:1500px) {\n\n    .earn-container {\n        max-width: 95%;\n    }\n\n    .earn-hero-title {\n        font-size: 48px;\n    }\n\n}\n\n\n@media (max-width: 1200px) {\n\n\n    .earn-hero-right {\n        width: 50%;\n    }\n\n    .products-header-row h2 {\n        font-size: 32px;\n    }\n\n    .faq-title {\n        font-size: 32px;\n        margin: 0 0 26px 0;\n    }\n\n}\n\n@media (max-width: 991px) {\n\n\n    .earn-hero-title {\n        font-size: 32px;\n        margin-bottom: 10px;\n    }\n\n    .earn-hero-desc {\n        font-size: 15px;\n        margin: 0 0 22px 0;\n    }\n\n    .earn-new-page {\n        padding: 40px 0 40px 0;\n    }\n\n\n    .faq-card-question {\n        font-size: 15px;\n    }\n\n    .earn-crypto-bar {\n        grid-template-columns: repeat(2, 1fr);\n    }\n\n    .products-header-row {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 16px;\n    }\n}\n\n@media (max-width: 767px) {\n\n\n    .earn-hero {\n        text-align: center;\n        flex-direction: column;\n        gap: 30px;\n        margin-bottom: 40px;\n    }\n\n    .earn-badges-row {\n        justify-content: center;\n        margin-bottom: 24px;\n    }\n\n    .earn-badge-pill {\n        gap: 6px;\n        padding: 7px 14px;\n        font-size: 13px;\n    }\n\n    .btn-start-earning {\n        gap: 8px;\n        padding: 10px 26px;\n        font-size: 12px;\n    }\n\n    .earn-hero-right {\n        width: 280px;\n    }\n\n    .products-header-row h2 {\n        font-size: 24px;\n    }\n\n    .faq-title {\n        font-size: 24px;\n        margin: 0 0 24px 0;\n    }\n\n    .all-products-section {\n        margin-bottom: 40px;\n    }\n\n    .earn-faq-section {\n        margin-bottom: 20px;\n    }\n\n    .faq-card-item {\n        padding: 18px;\n    }\n\n}\n\n\n@media (max-width: 580px) {\n\n    .earn-crypto-bar {\n        grid-template-columns: repeat(1, 1fr);\n    }\n\n    .crypto-apy-card {\n        display: flex;\n        justify-content: space-between;\n        align-items: start;\n    }\n\n    .crypto-apy-rate {\n        font-size: 18px;\n    }\n\n    .earn-feature-card {\n        border-radius: 20px;\n        padding: 22px;\n    }\n\n    .faq-grid-2col {\n        grid-template-columns: 1fr;\n    }\n\n    .earn-features-grid {\n        grid-template-columns: 1fr;\n        margin-bottom: 40px;\n    }\n\n    .faq-title {\n        font-size: 22px;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
